<template>
  <div class="c-sidebar">
    <div class="c-sidebar__logo" @click="$router.push('/')">
      <div class="c-sidebar__logo-icon">
        <Avatar icon="logo-chrome"></Avatar>
      </div>
      后台管理系统
    </div>
    <Menu
      ref="menu"
      theme="dark"
      :active-name="activeName"
      width="auto"
      :open-names="openNames"
      @on-select="handleSelect"
    >
      <Submenu
        v-for="(menu1, index1) in sidebarMenu"
        :key="index1"
        :name="menu1.name"
      >
        <template slot="title">
          <Icon :type="menu1.icon" />
          {{ menu1.title }}
        </template>

        <template
          v-for="(menu2, index2) in menu1.children"  
        >
          <Submenu
            v-if="menu2.children"
            :key="index2"
            :name="menu2.name"
          >
            <template slot="title">
              <span class="submenuloop2txt">{{ menu2.title }}</span>
            </template>
            <MenuItem
              style="padding-left:70px !important;"
              v-for="(menu3, index3) in menu2.children"
              :key="index3"
              :name="menu3.route"
            >
              {{ menu3.title }}
            </MenuItem>
          </Submenu>

          <MenuItem
            v-if="!menu2.children"
            :key="index2"
            :name="menu2.route"
          >
            {{ menu2.title }}
          </MenuItem>
        
        </template>
        
      </Submenu>
    </Menu>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import getSidebarMenu from "@/utils/get-sidebar-menu";

@Component
export default class TheSidebar extends Vue {
  activeName = "";
  openNames = [];

  get sidebarMenu() {
    return getSidebarMenu(this.getSchoolId());
  }

  created() {
    this.update();
  }

  handleSelect(name) {
    this.$router.push(name);
  }

  update(route) {
    const path = route ? route.path : this.$route.path;
    const paths = path.split("/");
    this.openNames = [paths[1],paths[2]];
    this.activeName = path;
        // paths.length === 6
        // ? `/${paths[1]}/${paths[2]}/${paths[3]}/${paths[4]}/${paths[5]}`
        // : `/${paths[1]}/${paths[2]}/${paths[3]}`;

    if (paths.length === 3) {
      this.activeName = `/${paths[1]}/${paths[2]}/list`;
    }
    if (paths.length === 6) {
      this.activeName = `/${paths[1]}/${paths[2]}/${paths[3]}/${paths[4]}`;
    }

    this.$nextTick(() => {
      this.$refs.menu.updateActiveName();
      this.$refs.menu.$children.forEach(item => {
        item.opened = false;
      });
      this.$refs.menu.updateOpened();
    });
  }
}
</script>

<style lang="scss" src="./style.scss"></style>
<style>
  .submenuloop2txt {
      font-size: 12px;
      padding-left: 7px !important;
  }
</style>
